import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamondLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.1277 1.8772C11.1597 1.84101 12.1637 2.25171 12.9932 3.0812L17.1252 7.21312C17.9564 8.0443 18.3677 9.04835 18.331 10.0804C18.2945 11.1057 17.8189 12.0898 17.006 12.9027L13.1125 16.7963C12.3 17.6088 11.316 18.0843 10.2908 18.1208C9.25867 18.1576 8.25444 17.7462 7.42287 16.9146L3.29094 12.7827C2.45974 11.9515 2.04857 10.9476 2.08554 9.91568C2.12226 8.8906 2.59812 7.90677 3.4109 7.09398C3.41088 7.09399 3.41091 7.09396 3.4109 7.09398L7.30362 3.20043C8.11702 2.3875 9.1025 1.91315 10.1277 1.8772ZM8.18743 4.08439C8.18737 4.08445 8.18749 4.08434 8.18743 4.08439L4.29487 7.97777C3.66442 8.60827 3.35822 9.30485 3.33474 9.96043C3.3115 10.609 3.56196 11.2859 4.17482 11.8989L8.30675 16.0308C8.92008 16.6441 9.59742 16.8948 10.2463 16.8717C10.9022 16.8483 11.5987 16.5423 12.2286 15.9123L16.1221 12.0189C16.7525 11.3885 17.0585 10.6918 17.0818 10.036C17.1049 9.3871 16.8542 8.70985 16.2413 8.097L12.1094 3.96508C11.4988 3.35456 10.8217 3.10363 10.1716 3.12643C9.51492 3.14946 8.81725 3.455 8.18743 4.08439Z",
		fill: "currentColor"
	})
});
export default SvgDiamondLine;
